"use strict";exports.msToParts=function(o){var s=o<0,t=Math.abs(o),e=Math.round(t%1e3),r=Math.floor(t/1e3%60),a=Math.floor(t/6e4%60);return{hours:Math.floor(t/36e5%24),isNegative:s,milliseconds:e,minutes:a,seconds:r}};
//# sourceMappingURL=msToParts.cjs.map
